import { render, staticRenderFns } from "./TPassDetailContent.vue?vue&type=template&id=9a88338e&"
import script from "./TPassDetailContent.vue?vue&type=script&lang=js&"
export * from "./TPassDetailContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports